
export default function Resume () {
    return(
        <div id='resume'>
            <div id='work-history'>
                <h2 id='title'>Work History</h2>
                        Johnny's New York Style Pizza (Current Employer)
                            <ul className='resume'>
                                <li>Prepared and cooked food in a fast-paced environment, ensuring quality and efficiency.</li>
                                <li>Managed kitchen operations during high-volume shifts, delegating tasks to team members and ensuring timely completion of closing duties.</li>
                                <li>Developed strong teamwork and communication skills while maintaining a positive attitude under pressure.</li>
                            </ul>
                        Carter's Warehouse
                            <ul className='resume'>
                                <li>Sorted, packed, and picked baby clothes to fulfill orders.</li>
                                <li>Demonstrated attention to detail to ensure correct inventory tracking.</li>
                                <li>Worked efficiently in a team environment to meet daily quotas.</li>
                                <li>Processed an average of 500 orders per day with 99.5% accuracy rate.</li>
                            </ul>
                        Taco Bell
                            <ul className='resume'>
                                <li>Coordinated operations during peak hours, managing a team of up to 10 employees to ensure customer satisfaction.</li>
                                <li>Facilitated communication between team members, resolving conflicts and ensuring a positive work environment.</li>
                                <li>Demonstrated leadership skills by delegating tasks and following up to ensure timely completion.</li>
                                <li>Increased customer satisfaction ratings by 25% through improved order accuracy and speed of service.</li>
                            </ul>
                        Interline Brands
                            <ul className='resume'>
                                <li>Picked and prepared orders of construction/home improvement supplies for shipment.</li>
                                <li>Was consistently in the top 3 pickers of my shift, exceeding daily quotas by 20%.</li>
                                <li>Operated forklifts and other warehouse equipment to move heavy items.</li>
                                <li>Maintained a safe and clean work environment, adhering to company policies and procedures.</li>
                            </ul>
                        Taco Mac
                        <ul>
                            <li>Maintained cleanliness and organization of kitchen, washing dishes and assisting with prep work.</li>
                            <li>Demonstrated multitasking abilities in a fast-paced environment, ensuring timely completion of tasks.</li>
                            <li>Developed strong communication skills by working closely with kitchen staff to ensure smooth operations.</li>
                        </ul>
                        Mizuno
                        <ul>
                            <li>Picked and prepared orders of sports equipment for shipment.</li>
                            <li>Ensured accuracy in inventory tracking and order fulfillment.</li>
                            <li>Demonstrated strong work ethic and attention to detail, exceeding daily quotas.</li>
                        </ul>
                        Pizza Hut
                        <ul>
                            <li>Prepared and cooked pizzas to customer specifications, ensuring quality and accuracy.</li>
                            <li>Maintained cleanliness and organization of kitchen and workstations.</li>
                            <li>Demonstrated ability to work in a fast-paced environment while maintaining a positive attitude.</li>
                        </ul>
                        Dish Network
                        <ul>
                            <li>Assembled and boxed receivers and remotes on a conveyor belt.</li>
                            <li>Maintained a consistent work pace to meet daily quotas.</li>
                            <li>Demonstrated attention to detail, ensuring accuracy in product assembly.</li>
                        </ul>
                        AES Clean Technology
                        <ul>
                            <li>Assembled doors, windows, and walls for clean environments.</li>
                            <li>Maintained a clean and organized work area, adhering to company policies and safety regulations.</li>
                            <li>Inspected finished products to ensure they met quality standards and made necessary adjustments as required.</li>
                        </ul>
            </div>
        </div>
    )
}